import React from "react";
import { Layout, Button, Card, Typography } from 'antd';
import { LockOutlined, RocketOutlined } from '@ant-design/icons';
import LayoutHome from "../../../components/layout/LayoutHome";
import { Link } from 'react-router-dom';
const { Title, Text } = Typography;

const VentanaCajaCerrada = () => {
    return (
        <LayoutHome>
            <Layout style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center', background: '#f8fafc' }}>

                <div style={{ maxWidth: '480px', width: '100%', padding: '0 20px', animation: 'fadeIn 0.5s' }}>
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: '24px',
                            textAlign: 'center',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                        }}
                    >
                        <div style={{ background: '#fef2f2', width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                            <LockOutlined style={{ fontSize: '40px', color: '#ef4444' }} />
                        </div>

                        <Title level={3} style={{ color: '#0f172a', marginBottom: '8px', fontWeight: '800' }}>
                            Caja Cerrada
                        </Title>

                        <Text style={{ fontSize: '15px', color: '#64748b', display: 'block', marginBottom: '32px', lineHeight: '1.6' }}>
                            Para poder registrar ventas y facturar a tus clientes, primero debes realizar la apertura de caja y registrar tu base inicial.
                        </Text>

                        <Link to="/cierre-caja">
                            <Button
                                type="primary"
                                size="large"
                                block
                                icon={<RocketOutlined style={{ fontSize: '20px' }} />}
                                style={{
                                    height: '55px',
                                    borderRadius: '14px',
                                    backgroundColor: '#22BABB',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    boxShadow: '0 4px 6px -1px rgba(34, 186, 187, 0.3)'
                                }}
                            >
                                IR A ABRIR CAJA
                            </Button>
                        </Link>
                    </Card>
                </div>

            </Layout>
        </LayoutHome>
    )
}

export default VentanaCajaCerrada;